export const agentDomains = [
  'agent.sandbox.hagerty.com',
  'agent.ci.hagerty.com',
  'agent.preprod.hagerty.com',
  'agent.hagerty.com',
];
export const stfrm = 'STFRM';
export const stfrmAgent = 'stfrm-agent';
export const stfrmCustomer = 'stfrm-customer';
